"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";

export default function Page() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch("/api/web-content");
        if (response.ok) {
          const data = await response.json();
          if (data?.generalTerms) {
            setContent(data.generalTerms);
            document.title = `${data.generalTerms.title || "Terms & Conditions"} || Arena Water Park`;
          }
        }
      } catch (error) {
        console.error("Failed to fetch Terms & Conditions:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh", width: "100%" }}>
        <div className="spinner-border" role="status" style={{ color: "var(--theme-color, #F55B1F)", width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{ backgroundImage: 'url("/assets/img/banners/terms_bg.webp")' }}
      >
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  {content?.title || "Terms & Conditions"}
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>{content?.title || "Terms & Conditions"}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section
        id="about"
        className="about-section fix section-padding scrollSpySection"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="row">
              <div className="col-lg-12">
                {content?.content ? (
                  <div 
                    className="wysiwyg-content"
                    dangerouslySetInnerHTML={{ __html: content.content }} 
                  />
                ) : (
                  <p>No content available yet.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
